// Luźniejsza normalizacja zapytania wyszukiwania — stosowana PRZED wysłaniem do API
// (backend robi resztę: per-token substring match na nazwie, patrz search.py/panel_search.py
// w repo scraperów). Zakres celowo wąski — każdy alias niżej został zweryfikowany na
// realnych danych (patrz raport TASK 3): dodajemy tylko to, co faktycznie poprawia wynik.
//
// Świadomie POMINIĘTE (sprawdzone jako nieskuteczne albo ryzykowne z samego frontu):
//   - odrzucanie jednostek mocy/pojemności (np. "8kw" -> nic) — na realnych danych zamienia
//     precyzyjne dopasowanie w "całą kategorię" (np. huawei 8kw m1: 4 -> 82 wyników).
//   - transliteracja polskich znaków — backend USUWA znaki diakrytyczne zamiast je
//     transliterować, więc zgadywanie ASCII-formy z frontu bywa gorsze niż brak zmiany.
//   Oba wymagają zmiany backendu (opisane w raporcie), nie hacku po stronie frontu.

// Kolejność ma znaczenie: dłuższe/bardziej specyficzne frazy pierwsze.
const ALIASES = [
  [/\bja[\s-]solar\b/gi, 'jasolar'],
  [/\bfox[\s-]ess\b/gi, 'foxess'],
  [/\bsol[\s-]planet\b/gi, 'solplanet'],
  [/\bsun[\s-]2000\b/gi, 'sun2000'],
  [/\bfull[\s-]black\b/gi, 'fullblack'],
  [/\bhybryda\b/gi, 'hybrydowy'],
  [/\bhybryd\b/gi, 'hybrydowy'],
  [/\bhybrid\b/gi, 'hybrydowy'],
];

export const normalizeSearchQuery = (raw) => {
  if (!raw || typeof raw !== 'string') return raw || '';
  let s = raw;
  ALIASES.forEach(([pattern, replacement]) => { s = s.replace(pattern, replacement); });
  return s.replace(/\s+/g, ' ').trim();
};
